{
    "step_of": "Step {{current}} of {{total}}",
    "next": "Next",
    "back": "Back",
    "skip": "Skip the tour",
    "finish": "Start using it",
    "replay": "Take the tour",
    "close": "Close the tour"
}
